module.exports = __webpack_public_path__ + "img/download-sum.cfef07b7.svg";